/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 安全装置
 */
export type FindEmsContactSafetyEquipmentsEnum =
  (typeof FindEmsContactSafetyEquipmentsEnum)[keyof typeof FindEmsContactSafetyEquipmentsEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactSafetyEquipmentsEnum = {
  SEAT_BELT: 'SEAT_BELT',
  AIR_BAG: 'AIR_BAG',
  CHILD_SEAT: 'CHILD_SEAT',
  HELMET: 'HELMET',
} as const;
